"use strict";

import Dom from "common/Dom";
import mixitup from "mixitup";
import mixitupPagination from "./mixitup-pagination";
mixitup.use(mixitupPagination);

// mixitup callbacks:
var onMixEnd = function onMixEnd() {
  var totalActiveFilters = $(Dom.collectionFiltersContainer).find(
    ".mixitup-control-active",
  ).length;
  $(Dom.filterCount).html(totalActiveFilters > 0 ? totalActiveFilters : "");
};
var config = {
  pagination: {
    limit: 50,
    hidePageListIfSinglePage: true,
    maintainActivePage: false,
  },
  animation: {
    enable: false,
  },
  callbacks: {
    onMixEnd: onMixEnd,
  },
};
var gridEl = document.querySelector(Dom.collectionGrid);
var mixer = gridEl ? mixitup(gridEl, config) : null;
export const sortBy = function sortBy(query) {
  if (mixer) mixer.sort(query);
};
export const clearFilters = function clearFilters() {
  if (mixer) mixer.filter("all");
};
